(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dropdown-localization"] && !Shopify.designMode) return;
  try {
    // Generic dropdown toggle for both country and language
  document.querySelectorAll('.dropdown-localization__button').forEach(button => {
    button.addEventListener('click', () => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      const isHidden = panel.hasAttribute('hidden');

      // Close any other dropdowns
      document.querySelectorAll('.localization-wrapper').forEach(p => p.setAttribute('hidden', ''));
      document.querySelectorAll('.dropdown-localization__button').forEach(b => b.setAttribute('aria-expanded', 'false'));

      if (isHidden) {
        panel.removeAttribute('hidden');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Close dropdown if click happens outside
  document.addEventListener('click', e => {
    if (!e.target.closest('.dropdown-localization')) {
      document.querySelectorAll('.localization-wrapper').forEach(p => p.setAttribute('hidden', ''));
      document.querySelectorAll('.dropdown-localization__button').forEach(b => b.setAttribute('aria-expanded', 'false'));
    }
  });
  } catch(e) { console.error(e); }
})();

})();
